import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import { HiOutlineShoppingBag } from 'react-icons/hi2';
import Icon from '../../utils/Icon';
import { useCart } from '../../context/CartContext';
import {
  HeaderContainer,
  HeaderContent,
  Logo,
  Nav,
  NavLink,
  HeaderActions,
  IconButtonExternal,
  IconButtonInternal,
  CartButtonWrapper,
  CartBadge,
} from './styles';

const Header: React.FC = () => {
  const { totalItems } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    } else {
      document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <HeaderContainer role="banner">
      <HeaderContent>
        <Logo to="/" aria-label="Viviane Balas — Página inicial">
          Viviane <span>Balas</span>
        </Logo>
        <Nav aria-label="Navegação principal">
          <NavLink href="#hero" onClick={(e) => handleAnchorClick(e, 'hero')}>Início</NavLink>
          <NavLink href="#catalogo" onClick={(e) => handleAnchorClick(e, 'catalogo')}>Produtos</NavLink>
          <NavLink href="#sobre" onClick={(e) => handleAnchorClick(e, 'sobre')}>Sobre</NavLink>
          <NavLink href="#contato" onClick={(e) => handleAnchorClick(e, 'contato')}>Contato</NavLink>
        </Nav>
        <HeaderActions>
          <IconButtonExternal
            className="whatsapp"
            href="https://wa.me/5532988583597"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Enviar mensagem pelo WhatsApp"
          >
            <Icon icon={FaWhatsapp} />
          </IconButtonExternal>
          <CartButtonWrapper>
            <IconButtonInternal to="/carrinho" aria-label={`Carrinho com ${totalItems} ${totalItems === 1 ? 'item' : 'itens'}`}>
              <Icon icon={HiOutlineShoppingBag} />
            </IconButtonInternal>
            {totalItems > 0 && <CartBadge aria-hidden="true">{totalItems}</CartBadge>}
          </CartButtonWrapper>
        </HeaderActions>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;

